import {ClassComponent, Vnode} from 'mithril';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import LightboxState from '../states/LightboxState';
import PictureShow from './PictureShow';

interface LightboxAttrs {
    state: LightboxState
}

export default class Lightbox implements ClassComponent<LightboxAttrs> {
    view(vnode: Vnode<LightboxAttrs>) {
        const {state} = vnode.attrs;

        if (!state.isOpen()) {
            return;
        }

        return m('.CimaiseLightbox', [
            // On mobile, we need our own header area to cover the original one
            m('.App-navigation'),
            m('.ButtonGroup App-backControl CimaiseLightboxClose', Tooltip.component({
                text: 'Close lightbox',
                // Must manually set position otherwise it goes up behind the header
                position: 'bottom',
            }, Button.component({
                className: 'Button Button--icon',
                icon: 'fas fa-times',
                onclick() {
                    state.close();
                },
            }))),
            m('.CimaiseLightboxContent', state.pictureId ? m(PictureShow, {
                id: state.pictureId,
                key: state.pictureId,
            }) : null),
        ]);
    }
}
